import api from './api';

export interface Domain {
  _id: string;
  name: string;
  description?: string;
}

export interface Owner {
  _id: string;
  name: string;
  type: 'Team' | 'Department' | 'Individual' | 'External';
  department?: string;
  email?: string;
}

export interface LookupData {
  domains: Domain[];
  owners: Owner[];
  assetTypes: string[];
  statuses: string[];
  certifications: string[];
}

/**
 * Lookup Service
 * Fetches dropdown/picklist data from the backend
 */
const lookupService = {
  /**
   * Get all active domains
   */
  getDomains: async (): Promise<Domain[]> => {
    try {
      const response = await api.get('/lookups/domains');
      return response.data.data;
    } catch (error) {
      console.error('Error fetching domains:', error);
      throw error;
    }
  },

  /**
   * Get all active owners
   */
  getOwners: async (): Promise<Owner[]> => {
    try {
      const response = await api.get('/lookups/owners');
      return response.data.data;
    } catch (error) {
      console.error('Error fetching owners:', error);
      throw error;
    }
  },

  /**
   * Get all asset types
   */
  getAssetTypes: async (): Promise<string[]> => {
    try {
      const response = await api.get('/lookups/asset-types');
      return response.data.data;
    } catch (error) {
      console.error('Error fetching asset types:', error);
      throw error;
    }
  },

  /**
   * Get all statuses
   */
  getStatuses: async (): Promise<string[]> => {
    try {
      const response = await api.get('/lookups/statuses');
      return response.data.data;
    } catch (error) {
      console.error('Error fetching statuses:', error);
      throw error;
    }
  },

  /**
   * Get all certifications
   */
  getCertifications: async (): Promise<string[]> => {
    try {
      const response = await api.get('/lookups/certifications');
      return response.data.data;
    } catch (error) {
      console.error('Error fetching certifications:', error);
      throw error;
    }
  },

  /**
   * Get all lookup data in one call (more efficient)
   */
  getAllLookups: async (): Promise<LookupData> => {
    try {
      const response = await api.get('/lookups/all');
      return response.data.data;
    } catch (error) {
      console.error('Error fetching all lookups:', error);
      throw error;
    }
  }
};

export default lookupService;
